import script from "./RecipeStep.vue?vue&type=script&lang=ts"
export * from "./RecipeStep.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__